import { ReactNode, useEffect } from 'react'
import { useCartButton } from 'hooks'

interface NoCartLayoutProps {
  children: ReactNode
}

export const NoCartLayout = ({ children }: NoCartLayoutProps) => {
  const { hideCartButton } = useCartButton()

  useEffect(() => {
    hideCartButton()
  }, [hideCartButton])

  return children
}
